import { ThemeSelector } from '@almbrand/themeselector';
import { PageType } from 'components/PageType';
import { CONTENT_DELIVERY_API_URL } from 'constantsValues';
import { useMemo } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import styles from './App.module.scss';
import { ThemeNames } from './constantsValues';
import { Page as PageContent, PageContext } from './context/PageContext';
import { apiInstance } from './services/Api';
import { purifyApiUrl } from './services/purifyApiUrl';

const App = () => {
	const location = useLocation();

	const { data, error, isLoading } = useSWR(location.pathname, (): any => {
		return apiInstance().get(purifyApiUrl(location.pathname, CONTENT_DELIVERY_API_URL));
	});

	const pageValue = useMemo(() => new PageContent(data), [data]);
	const themeName = ThemeNames[pageValue?.theme];

	// Temporary fix for overflow issue on iframe. Remove when we go live with the other car flow
	const isCodanCalculator = ['/bil', '/indbo', '/hus', '/elbil', '/rejse', '/ulykke'].some((path) =>
		globalThis.location.href.includes(`https://beregn.codan.dk${path}`)
	);

	console.log('Is Codan calculator:', isCodanCalculator);

	return (
		<ThemeSelector themeName={themeName}>
			{error && <div>Error fetching content: {error.message}</div>}
			<div
				className={styles.App}
				// Fix for overflow issue on iframe. Remove when we go live with the other car flow
				style={isCodanCalculator ? { overflow: 'auto' } : undefined}
			>
				{isLoading}
				{data && (
					<PageContext.Provider value={pageValue}>
						<Routes>
							{/* <Route path='/'> */}
							<Route
								path='/:flowName'
								element={<PageType />}
							/>
							{/* </Route> */}
						</Routes>
						{/* <PageType /> */}
					</PageContext.Provider>
				)}
			</div>
		</ThemeSelector>
	);
};

export default App;
